import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Children, isValidElement } from 'react';
import { isReactFragment } from '../../index.js';
import { ThumbnailButton } from './ThumbnailButton.js';
const getSrcImage = (element) => {
    var _a, _b;
    return ((element === null || element === void 0 ? void 0 : element.imgSrc) ||
        (element === null || element === void 0 ? void 0 : element.src) ||
        ((_a = element === null || element === void 0 ? void 0 : element.children) === null || _a === void 0 ? void 0 : _a.props.imgSrc) ||
        ((_b = element === null || element === void 0 ? void 0 : element.children) === null || _b === void 0 ? void 0 : _b.props.src) ||
        (element === null || element === void 0 ? void 0 : element.poster) ||
        '');
};
const getAltImage = (element) => {
    var _a, _b;
    return ((element === null || element === void 0 ? void 0 : element.imgAlt) ||
        (element === null || element === void 0 ? void 0 : element.alt) ||
        ((_a = element === null || element === void 0 ? void 0 : element.children) === null || _a === void 0 ? void 0 : _a.props.imgAlt) ||
        ((_b = element === null || element === void 0 ? void 0 : element.children) === null || _b === void 0 ? void 0 : _b.props.alt) ||
        '');
};
const getChildProps = (element) => {
    var _a;
    const child = (_a = element === null || element === void 0 ? void 0 : element.props) === null || _a === void 0 ? void 0 : _a.children;
    if (child.props.imgSrc || child.props.src)
        return child.props;
    if (child.props.children.props.imgSrc || child.props.children.props.src)
        return child.props.children.props;
    return null;
};
export const VerticalImageGalleryDots = ({ childArray, imageComponent, imageComponentProps, maxNumberOfItemsToDisplay, onLastDisplayedItemClick, }) => {
    const galleryDots = childArray.map((child, pIndex) => {
        if (!isValidElement(child))
            return null;
        const itemsNumberHardLimit = 10;
        if (maxNumberOfItemsToDisplay === undefined ||
            maxNumberOfItemsToDisplay > itemsNumberHardLimit) {
            maxNumberOfItemsToDisplay = itemsNumberHardLimit;
        }
        const isChildFragment = isReactFragment(child);
        const nestedChildArray = isChildFragment
            ? Children.toArray(child.props.children)
            : [child];
        const isNested = nestedChildArray.length > 1;
        const totalNumberOfItems = isNested
            ? nestedChildArray.length
            : childArray.length;
        const numberOfHiddenItems = maxNumberOfItemsToDisplay
            ? totalNumberOfItems - maxNumberOfItemsToDisplay
            : 0;
        return nestedChildArray
            .slice(0, itemsNumberHardLimit)
            .map((child, index) => {
            if (!isValidElement(child))
                return null;
            const childProps = getChildProps(child);
            if (!childProps)
                return null;
            const isVideo = childProps === null || childProps === void 0 ? void 0 : childProps.videoSrc;
            const isLastDisplayedItem = maxNumberOfItemsToDisplay
                ? isNested
                    ? index === maxNumberOfItemsToDisplay - 1
                    : pIndex === maxNumberOfItemsToDisplay - 1
                : false;
            const shouldOverlayLastDisplayedItem = isLastDisplayedItem && numberOfHiddenItems > 0;
            if (!isNested &&
                maxNumberOfItemsToDisplay &&
                pIndex >= maxNumberOfItemsToDisplay)
                return null;
            return (_jsx(ThumbnailButton, Object.assign({}, childProps, { index: isChildFragment ? index : pIndex, isVideo: isVideo, src: getSrcImage(childProps), alt: getAltImage(childProps), imageComponent: imageComponent, imageComponentProps: imageComponentProps, shouldOverlayLastDisplayedItem: shouldOverlayLastDisplayedItem, numberOfHiddenItems: numberOfHiddenItems, isHiddenOnDesktop: maxNumberOfItemsToDisplay
                    ? index >= maxNumberOfItemsToDisplay
                    : index >= itemsNumberHardLimit, onLastDisplayedItemClick: onLastDisplayedItemClick }), `button-gallery-${pIndex}-${index}`));
        });
    });
    return _jsx(_Fragment, { children: galleryDots });
};
VerticalImageGalleryDots.displayName = 'VerticalImageGalleryDots';
//# sourceMappingURL=VerticalImageGalleryDots.js.map